import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import OAuthSignIn from './pages/OAuthSignIn';
import EuGrantLearnMore from './pages/EUGrantLearnMore';
import Chat from './pages/Chat';
import ChatComponent from './pages/TextStreamingChat';
import { RequireLogin } from '../helper';
import { UserProvider } from '../hooks/useUser';
import { commonRoutes } from '../commonPages/CommonRoutes';
import UserSettings from './pages/UserSettings';
import { Toaster } from 'react-hot-toast';
import Playground from './pages/Playground';
import ApiDocs from './pages/ApiDocs';
import ManageDatabase from './pages/ManageDatabase';
import ManageApi from './pages/ManageApi';
import ExternalOAuthSignIn from './pages/ExternalOAuthSignIn';
import NLLanding from './pages/NLLanding';
import AboutUs from './pages/AboutUs';
const ThoughtfulOasisIndex = () => {
    return(
        <UserProvider mountingScreen={<></>}>
            <Helmet>
            <meta name="description" content="Thoughtful Oasis is a startup that builds search engines for language-driven industries." />
            <meta name="keywords" content="search, engine, language, industries, retrieval, augmented, generation, ontology, vector, database" />
            <title>Thoughtful Oasis</title>
            <link rel="icon" href="/assets/rhea/logo.png" />
        </Helmet>
            <BrowserRouter future={{ v7_startTransition: true }} basename={''}>
                <Toaster />
                <Routes>
                    <Route path="/" element={<NLLanding />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/playground" element={<Playground />} />
                    <Route path="/knowledge-base/:Database_id" element={<ManageDatabase />} />
                    <Route path="/manage-api" element={<ManageApi />} />
                    <Route path="/api-docs" element={<ApiDocs />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/streaming-chat" element={<ChatComponent />} />
                    <Route path="eu-grant-learn-more" element={<RequireLogin><EuGrantLearnMore /></RequireLogin>} />
                    <Route path="settings" element={<RequireLogin><UserSettings /></RequireLogin>} />,    
                    <Route path="oauth-signup" element={<OAuthSignIn />} />
                    <Route path="external-oauth-signup" element={<ExternalOAuthSignIn />} />
                    <Route path="*" element={<Navigate to="/" />} />
                    {commonRoutes}
                </Routes>
            </BrowserRouter>
        </UserProvider>
    )
}

export default ThoughtfulOasisIndex;